import { createConfirmation } from "react-confirm";
import AddNewCustomUnitConvertDialog from "./AddNewCustomUnitConvertDialog";

export const showAddNewCustomUnitConvertDialog = createConfirmation(AddNewCustomUnitConvertDialog);
